import { render } from "./SystemLayout.vue?vue&type=template&id=9ade4bc0"
import script from "./SystemLayout.vue?vue&type=script&lang=js"
export * from "./SystemLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/crm.thebcr.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__